var r={radioItem:"rl2_radio-module_radioItem_-qq5g",radio:"rl2_radio-module_radio_zwYeE"};export{r as default};
